export const RouteName = {
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  CHANGE_PASSWORD: "/change-password",
  DASHBOARD: "/dashboard",
  ACCOUNT: "/accounts",
  ACTIVITY_LOG: "/activity-logs",
  CREATE_ACCOUNT: "/accounts/create",
  EDIT_ACCOUNT: "/accounts/:id/edit",
  ACCOUNT_FINANCe: "/accounts/:id/finance",
  ACCOUNT_DETAIL: "/accounts/:id",
  FLEET_MODEL: "/fleet-models",
  CREATE_FLEET_MODEL: "/fleet-models/create",
  EDIT_FLEET_MODEL: "/fleet-models/:id/edit",
  FLEET_MODEL_DETAIL: "/fleet-models/:id",
  TRIP_DETAIL: "/trips/:id",
  CARPOOLING_DETAIL: "/carpooling/:id",
  CITY: "/cities",
  CREATE_CITY: "/cities/create",
  EDIT_CITY: "/cities/:id/edit",
  FAQ: "/faqs",
  CREATE_FAQ: "/faqs/create",
  EDIT_FAQ: "/faqs/:id/edit",
  DRIVER: "/drivers",
  DRIVER_SEARCH: "/drivers/search",
  DRIVER_RANKINGS: "/drivers/rankings",
  CREATE_DRIVER: "/drivers/create",
  EDIT_DRIVER: "/drivers/:id/edit",
  DRIVER_DETAIL: "/drivers/:id",
  DRIVER_QRCODE: "/drivers/:qrcode/qrcode",
  DRIVER_WALLET: "/driver-wallets",
  EDIT_DRIVER_WALLET: "/driver-wallets/:id/edit",
  DRIVER_WALLET_DETAIL: "/drivers/:id/wallet",
  FLEET: "/fleets",
  EDIT_FLEET: "/fleets/:id/edit",
  FLEET_DETAIL: "/fleets/:id",
  DISPATCHER: "/dispatchers",
  NEWS_BROADCAST: "/new-broadcast",
  NEWS: "/news",
  NEW_NEWS: "/news/new-news",
  PROMO_CODE: "/promo-codes",
  CHAPA_TRANSACTION_SUCCESS: "/transactions/initiate/chapa/success",
  NEW_PROMO: "/new-promo",
  RATING: "/ratings",
  PLACE: "/places",
  CREATE_PLACE: "/places/create",
  VIEW_PLACES_ON_MAP: "/places/view-on-map",
  EDIT_PLACE: "/places/:id/edit",
  TRIP: "/trips",
  TRIP_ROUTE: "/trips/:id/route",
  TRIP_ROUTE_OLD: "/trips/:id/route/old",
  TRIP_ROUTE_ESTIMATION: "/trips/:id/route/estimation",
  TRIP_ROUTE_POINTS: "/trips/:id/route/points",
  TRIP_REQUEST: "/trip-requests",
  CARPOOLING: "/carpooling",
  CARPOOLING_ROUTE: "/carpooling/:id/route",
  CARPOOLING_ROUTE_POINTS: "/carpooling/:id/route/points",
  CARPOOLING_REQUEST: "/trip-requests",
  PASSENGER: "/passengers",
  PASSENGER_DETAIL: "/passengers/:id",
  PASSENGER_WALLET: "/passenger-wallets",
  PASSENGER_WALLET_DETAIL: "/passengers/:id/wallet",
  FINANCE: "/finances",
  FINANCE_DASHBOARD: "/finances/dashboard",
  APP_VERSION: "/app-versions",
  OTP: "/otp",
  CREATE_APP_VERSION: "/app-versions/create",
  SETTING: "/settings",
  EDIT_TRIP: "/trips/:id/edit",
  REPORT_REQUEST: "/report-requests",
  SOS: "/sos",
  SOS_DETAIL: "/sos/:id",
  SOS_TRACKING: "/soses/:id/detail",
  TRACK_DRIVER: "/driver/:id/location",
  TRACK_PASSENGER: "/passenger/:id/location",
  TRACK_SCHOOL_CARPOOLING: "/school-carpooling/parent/track/:id",
  STUCK_DRIVERS: "/stuck-drivers",
  PENALTY_MANAGEMENT: "/penalties",
  LOTTERY_MANAGEMENT: "/lottery",
  SYSTEM_HEALTH: "/system-health",
};

export const UnAuthenticatedRoutes = [
  RouteName.LOGIN,
  RouteName.FORGOT_PASSWORD,
  RouteName.RESET_PASSWORD,
  RouteName.CHAPA_TRANSACTION_SUCCESS,
  RouteName.TRACK_DRIVER,
  RouteName.TRACK_PASSENGER,
  RouteName.TRACK_SCHOOL_CARPOOLING,
];
